import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { InstallationCustomerInfoPluginService } from './customer-info.service';
import { ModalComponent } from '../../../modal/modal.component';
import { LocalEntityService } from './../../../shared/services';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'installation-customer-info-edit',
  templateUrl: './customer-info-edit.component.html',
  standalone: false
})
export class InstallationCustomerInfoEditPageComponent extends BaseInstallationEditPageComponent implements OnInit, OnDestroy {
  @ViewChild('languagesModal', { static: true })
  languageModal: ModalComponent;
  @ViewChild('countriesModal', { static: true })
  countriesModal: ModalComponent;
  @ViewChild('localEntitiesModal', { static: true })
  localEntitiesModal: ModalComponent;
  customer: any;
  plugin: any;
  editForm: UntypedFormGroup;
  machineSalesForm: UntypedFormArray;
  languages: any;
  countries: any;
  localEntities: any;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected pluginService: InstallationCustomerInfoPluginService,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    private localEntityService: LocalEntityService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit() {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateCustomer(this.inspectionId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public openLanguagesSelector(): void {
    this.openGenericSelector(this.languages, this.languageModal, 'Language');
  }

  public openCountriesSelector(): void {
    this.openGenericSelector(this.countries, this.countriesModal, 'Country', true, true);
  }

  public openLocalEntitiesSelector(): void {
    this.openGenericSelector(this.localEntities, this.localEntitiesModal, 'LocalEntity', true);
  }

  public selectLanguagesMenu(item: any) {
    this.onSelectMenu(item, 'Language');
  }

  public selectCountriesMenu(item: any) {
    this.onSelectMenu(item, 'Country');
    const leToSelect = _.find(this.localEntities, (le: any) => _.indexOf(le.countries, item.selectedIndex) !== -1);
    if (leToSelect) {
      leToSelect.selectedIndex = leToSelect.value;
      this.selectLocalEntitiesMenu(leToSelect);
    }
  }

  public selectLocalEntitiesMenu(item: any) {
    this.onSelectMenu(item, 'LocalEntity');
  }

  private onSelectMenu(item: any, controlName: string) {
    const selectedIndex = this.editForm.controls[controlName].value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls[controlName].setValue(selectedIndex);
  }

  public onLanguagesMenuClose() {
    this.onSelectMenuClose('Language');
  }

  public onCountriesMenuClose(e: any) {
    this.onSelectMenuClose('Country');
  }

  public onLocalEntitiesMenuClose(e: any) {
    this.onSelectMenuClose('LocalEntity');
  }

  public add() {
    this.machineSalesForm.push(new UntypedFormControl());
  }

  public remove(i: number) {
    this.machineSalesForm.removeAt(i);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initForm() {
    this.machineSalesForm = new UntypedFormArray(this.customer.MachineSalesOrder?.map((s) => new UntypedFormControl(s)) || []);
    this.editForm = new UntypedFormGroup({
      CrmId: new UntypedFormControl(this.customer.CrmId),
      Name: new UntypedFormControl(this.customer.Name),
      Address: new UntypedFormControl(this.customer.Address),
      City: new UntypedFormControl(this.customer.City),
      Country: new UntypedFormControl(this.customer.Country),
      LocalEntity: new UntypedFormControl(this.customer.LocalEntity),
      MachineSalesOrder: this.machineSalesForm,
      Language: new UntypedFormControl(this.customer.Language)
    });
  }

  private newCutomer() {
    this.customer = {
      CrmId: '',
      Name: '',
      Address: '',
      City: '',
      Country: '',
      LocalEntity: '',
      Email: '',
      MachineSalesOrder: ['']
    };
  }

  private initData() {
    this.languages = _.orderBy(this.pluginService.getLanguages(), ['label']);

    this.pluginService.getCountries().subscribe((data: any) => {
      this.countries = _.orderBy(data, ['label']);
      this.localEntityService.getLocalEntities().subscribe((localEntities: any) => {
        this.localEntities = _.orderBy(localEntities, ['label']);

        this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((el) => {
          this.plugin = el;
          this.customer = el.inspection.insptectionInspectionCustomer;
          if (this.customer == null || this.customer.length === 0) {
            this.newCutomer();
          }

          this.initForm();
          this.cdRef.detectChanges();
        });
      });
    });
  }

  private openGenericSelector(values: any, modal: any, controlName: string, search: boolean = false, searchFromStart: boolean = false) {
    const selectedIndex = this.editForm.controls[controlName].value;
    this.openSelector(modal, values, selectedIndex, { search, searchFromStart });
  }

  private onSelectMenuClose(controlName: string) {
    this.editForm.controls[controlName].markAsTouched();
  }
}
